import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawIcon from "./RawWritePromptIcon.svg.jsx";

const WritePromptIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawIcon} {...props} />;
});

export default WritePromptIcon;
